




// import React, { useState } from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Button,
//     Box,
//     Typography,
//     Grid,
//     Divider,
// } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';
// import { Formik, Form } from 'formik';

// import { FaPlus } from "react-icons/fa6";
// import { MdPayment } from 'react-icons/md';

// import CustomInputLogin from '../../../../../Components/CustomInputLogin/CustomInputLogin';
// import '../BannerinputGetModal.css'; // Import external CSS
// import { MdCancel } from "react-icons/md";
// import * as Yup from 'yup';
// import { FiUpload } from 'react-icons/fi';
// import FileUploadComponent from '../../../../../Components/FileUploadComponent/FileUploadComponent';
// import ActiveInactiveRadio from '../../../../../Components/ActiveInactiveRadio/ActiveInactiveRadio';



// const OfferSectionModal = ({ open, onClose, setSubmittedValues, submittedValues }) => {
//     const [uploadedFile, setUploadedFile] = useState(null);

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 maxWidth: "600px",
//                 margin: "auto",
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px", // Target the Paper component
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">

//                         <Box>
//                             <Typography className="custom-title-text" fontSize="16px" color="white">
//                                 Offers
//                             </Typography>
//                         </Box>
//                     </DialogTitle>
//                 </Box>

//                 <Formik
//                     initialValues={{
//                         heading_title: '',
//                         heading_second_text: '',
//                         heading_sub_text: '',
//                         card_title: '',
//                         // status: "active",


//                         card_content: '',
//                         image: null,
//                     }}
//                     validationSchema={Yup.object({
//                         heading_title: Yup.string().required('Title is required'),
//                         heading_second_text: Yup.string().required('Title is required'),
//                         heading_sub_text: Yup.string().required('Title is required'),

//                         card_title: Yup.string().required('Title is required'),
//                         // status: Yup.string().required('Status is required'),
//                         card_content: Yup.string().required('Content is required'),
//                     })}
//                     onSubmit={(values, { resetForm }) => {
//                         // setSubmittedValues([...submittedValues, values]);
//                         // console.log(values, "values")
//                         console.log("Form values:", values);

//                         resetForm();

//                     }}
//                 >
//                     {({ handleSubmit, setFieldValue, resetForm, values }) => (
//                         <Form onSubmit={handleSubmit}>
//                             <DialogContent dividers>
//                                 <Grid container spacing={2}>
//                                     {/* Title and Subtitle on the left, Content on the right */}
//                                     <Grid item xs={12} md={12}>
//                                         <Grid container spacing={2}>
//                                             <Grid item xs={12}>
//                                                 <Typography variant='body2' sx={{ color: "#C38F51" }}>Heading</Typography>
//                                             </Grid>

//                                             <Grid item xs={12} md={6}>
//                                                 <CustomInputLogin
//                                                     label="Title"
//                                                     name="title"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Title"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                                 <CustomInputLogin
//                                                     label="Second Text"
//                                                     name="second_text"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Second Text"
//                                                 />
//                                             </Grid>

//                                             <Grid item xs={12}>
//                                                 <CustomInputLogin
//                                                     label="Subtext"
//                                                     name="sub_text"
//                                                     inputType="textarea"
//                                                     custPlaceholder="Enter Subtext"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12}>
//                                                 <Typography variant='body2' sx={{ color: "#C38F51" }}>Card Design</Typography>
//                                             </Grid>

//                                             <Grid item xs={12} md={6}>
//                                                 <CustomInputLogin
//                                                     label="Card Title"
//                                                     name="card_title"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Card Title"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6}>
//                                                 <FileUploadComponent name="image" uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} onFileUpload={(file) => setFieldValue('image', file)} />

//                                             </Grid>
//                                             {/* <Grid item xs={12} md={6}>
//                                                 <ActiveInactiveRadio name="status"
//                                                     value={values.status} // Ensure this is correctly passed from Formik
//                                                     onChange={(value) => setFieldValue('status', value)}// Update the Formik state when the radio button changes
//                                                 />
//                                             </Grid> */}

//                                             <Grid item xs={12}>
//                                                 <CustomInputLogin
//                                                     label="Content"
//                                                     name="content"
//                                                     inputType="textarea"
//                                                     custPlaceholder="Enter Content"
//                                                 />
//                                             </Grid>


//                                         </Grid>


//                                     </Grid>


//                                     {/* <Grid item xs={12} md={4}>
//                                         <FileUploadComponent name="image" uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} onFileUpload={(file) => setFieldValue('image', file)} />

//                                     </Grid> */}
//                                 </Grid>

//                                 {/* Action Buttons */}
//                                 {/* <DialogActions> */}
//                                 <Grid sx={{ display: "flex", justifyContent: 'end', mt: 4 }}>
//                                     <Grid>
//                                         <Button
//                                             onClick={() => {
//                                                 resetForm()
//                                                 setUploadedFile(null)
//                                             }}
//                                             variant="text"
//                                             // className="custom-clear-button"
//                                             sx={{
//                                                 // backgroundColor: "#C38F51",
//                                                 textTransform: "none",
//                                                 color: "white",
//                                                 fontSize: "16px",
//                                                 mr: "10px",
//                                                 // padding: "0px 40px",
//                                                 padding: { xs: "0px 20px", md: "0px 40px" },

//                                                 minHeight: "40px",
//                                                 borderRadius: "23px",
//                                                 background: "white",
//                                                 boxShadow: "none",
//                                                 color: "black",
//                                                 border: "1px solid black",
//                                                 "&:hover": {
//                                                     backgroundColor: "#3B4056",
//                                                     color: "white"
//                                                 },
//                                             }}
//                                         >
//                                             Cancel
//                                         </Button>
//                                         <Button
//                                             type="submit"
//                                             variant="contained"
//                                             // className="custom-ok-button"
//                                             sx={{
//                                                 // backgroundColor: "#C38F51",
//                                                 textTransform: "none",
//                                                 color: "white",
//                                                 fontSize: "16px",
//                                                 boxShadow: "none",

//                                                 // padding: "0px 40px",
//                                                 padding: { xs: "0px 20px", md: "0px 40px" },

//                                                 minHeight: "40px",
//                                                 borderRadius: "23px",
//                                                 background: "#C38F51 0% 0% no-repeat padding-box",
//                                                 "&:hover": {
//                                                     backgroundColor: "#3B4056",
//                                                     boxShadow: "none",

//                                                 },
//                                             }}
//                                         >
//                                             Submit
//                                         </Button>
//                                     </Grid>
//                                 </Grid>

//                             </DialogContent>

//                             {/* </DialogActions> */}
//                         </Form>
//                     )}
//                 </Formik>

//             </Box>
//         </Dialog >
//     );
// };

// export default OfferSectionModal;



import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
} from '@mui/material';
import { MdCancel } from "react-icons/md";
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import CustomInputLogin from '../../../../../Components/CustomInputLogin/CustomInputLogin';
import FileUploadComponent from '../../../../../Components/FileUploadComponent/FileUploadComponent';

import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../../ReduxStore/actions';
// import PreviewComponent from '../../PreviewComponent/PreviewComponent';
// import LandingPage from '../../Home/Preview/LandingPage';
import { clearTableGetId } from '../../../../../ReduxStore/Slices/TableId/TableIdGetSlice';
import { clearCustomerId } from '../../../../../ReduxStore/Slices/Operator/customerSlice';
import { toast } from 'react-toastify';
import PreviewComponent from '../../../PreviewComponent/PreviewComponent';


const AboutUsModal = ({ open, onClose, editData, section_name, ModalPreviewComponent }) => {
    const [uploadedFile, setUploadedFile] = useState(null);


    const role = sessionStorage.getItem('role')

    //   useEffect(() => {
    //     if (!open) return;
    //     const fetchData = async () => {
    //       const data1 = { data: {}, method: "get", apiName: `getAllRoles` };
    //       await dispatch(actions.GETALLROLES(data1));
    //     };
    //     fetchData();
    //   }, [dispatch, createRoleWithPermissions]);

    const dispatch = useDispatch()
    const { getAboutUsSectionById } = useSelector(state => state?.getAboutUsSectionById);
    const { addAboutUsSection } = useSelector(state => state?.addAboutUsSection);

    const { updateAboutUsSection } = useSelector(
        (state) => state?.updateAboutUsSection
    );

    const { deleteAboutUsSection } = useSelector(
        (state) => state?.deleteAboutUsSection
    );




    const { getAllAboutUsSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllAboutUsSectionsWithCreatorBySectionName
    );

    const { getAllAboutUsSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllAboutUsSectionsBySectionNameBasedOnCreator
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllAboutUsSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addAboutUsSectionWithApproval } = useSelector(
        (state) => state?.addAboutUsSectionWithApproval
    );




    const { updateAboutUsSectionForReApproval } = useSelector(
        (state) => state?.updateAboutUsSectionForReApproval
    );



    const [loading, setLoading] = useState(false);




    const [editResponseData, setEditResponseData] = useState()
    const TableId = useSelector((state) => state.Table.TableId);

    console.log(TableId, "TebleIddddd")

    useEffect(() => {
        console.log(TableId, "TebleIddddd111")

        if (TableId) {
            console.log(TableId, "TebleIddddd222")

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getAboutUsSectionById/${TableId}`,
                };
                const response = await dispatch(actions.GETABOUTUSSECTIONBYID(data1));

                console.log(response, "responseresponse")

                if (response?.payload?.message === "About Us section retrieved successfully.") {
                    console.log("hiiii")

                    setEditResponseData(response?.payload?.data)
                    setUploadedFile({
                        fileUrl: response?.payload?.data.additional_data[0]?.banner,
                        type: "img",
                        progress: 100,
                    }
                    )
                    // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, [open]);





    const handleSubmit = async (values, resetForm) => {
        setLoading(true)

        if (!TableId) {

            if (role === "superAdmin") {

                const data1 = {
                    data: {
                        section_name: section_name,//pass from parent component
                        heading: values?.heading_title,
                        sub_heading: values?.heading_second_text,
                        content: values?.heading_sub_text,
                        additional_data: {
                            card_design: values?.cards?.map((data) => ({
                                logo: data?.image?.fileUrl,
                                title: data?.card_title,
                                cart_title_secondtext: data?.cart_title_secondtext,

                                content: data?.card_content
                            }))
                        }
                    },
                    method: "Post",
                    apiName: `addAboutUsSectionWithApproval`
                };
                const responseData = await dispatch(actions.ADDABOUTUSSECTIONWITHAPPROVAL(data1));

                if (responseData?.payload?.message === "About Us section added and approved successfully. Previous approved section deactivated.") {
                    // handlePreviewCloseModal()

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()

                    //     resetForm()

                    //     setUploadedFile(null)

                    // }, 2500)

                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success(`About us section added successfully!!`)

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            } else {
                const data1 = {
                    data: {
                        section_name: section_name,
                        heading: values?.heading_title,
                        sub_heading: values?.heading_second_text,
                        content: values?.heading_sub_text,
                        additional_data: {
                            card_design: values?.cards?.map((data) => ({
                                logo: data?.image?.fileUrl,
                                title: data?.card_title,
                                cart_title_secondtext: data?.cart_title_secondtext,

                                content: data?.card_content
                            }))
                        }
                    },
                    method: "Post",
                    apiName: `addAboutUsSection`
                };
                const responseData = await dispatch(actions.ADDABOUTUSSECTION(data1));
                if (responseData?.payload?.message === "About Us section added successfully.") {
                    // handlePreviewCloseModal()

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()

                    //     resetForm()

                    //     setUploadedFile(null)

                    // }, 2500)

                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success("About us section added successfully!!")

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            }
        } else {

            if (role === "superAdmin") {

                const data1 = {
                    data: {
                        section_name: section_name,
                        heading: values?.heading_title,
                        sub_heading: values?.heading_second_text,
                        content: values?.heading_sub_text,
                        additional_data: {
                            card_design: values?.cards?.map((data) => ({
                                logo: data?.image?.fileUrl,
                                title: data?.card_title,
                                cart_title_secondtext: data?.cart_title_secondtext,

                                content: data?.card_content
                            }))
                        }
                    },
                    method: "put",
                    apiName: `updateAboutUsSection/${TableId}`
                };
                const responseData = await dispatch(actions.UPDATEABOUTUSSECTION(data1));

                if (responseData?.payload?.message === "About Us section updated successfully.") {
                    // handlePreviewCloseModal()

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()

                    //     resetForm()
                    //     dispatch(clearCustomerId(null))
                    //     dispatch(clearTableGetId(null))

                    //     setUploadedFile(null)

                    // }, 2500)
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success("About us section update successfully!!")

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
                else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            } else {
                const data1 = {
                    data: {
                        section_name: section_name,
                        heading: values?.heading_title,
                        sub_heading: values?.heading_second_text,
                        content: values?.heading_sub_text,
                        additional_data: {
                            card_design: values?.cards?.map((data) => ({
                                logo: data?.image?.fileUrl,
                                title: data?.card_title,
                                cart_title_secondtext: data?.cart_title_secondtext,

                                content: data?.card_content
                            }))
                        }
                    },
                    method: "put",
                    apiName: `updateAboutUsSectionForReApproval/${TableId}`
                };
                const responseData = await dispatch(actions.UPDATEABOUTUSSECTIONFORREAPPROVAL(data1));
                if (responseData?.payload?.message === "About Us section updated successfully.") {
                    // handlePreviewCloseModal()

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()
                    //     dispatch(clearCustomerId(null))
                    //     dispatch(clearTableGetId(null))

                    //     resetForm()

                    //     setUploadedFile(null)

                    // }, 2500)
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success("About us section update successfully!!")

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            }

        }
    }

    const [isPreviewModalOpen, setPreviewModalOpen] = useState(false)

    const handlePreviewOpenModal = () => {
        setPreviewModalOpen(true);
    };

    const handlePreviewCloseModal = () => {
        setPreviewModalOpen(false);
    };


    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            sx={{
                maxWidth: "600px",
                margin: "auto",
                "& .MuiPaper-root": { borderRadius: "14px" },
            }}
        >
            <Box sx={{ position: 'relative' }}>
                {/* Dialog Header */}
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            onClose()
                            dispatch(clearCustomerId(null))
                            dispatch(clearTableGetId(null))
                        }}
                        sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Typography fontSize="16px" color="white">
                            Offers
                        </Typography>
                    </DialogTitle>
                </Box>

                {/* Formik Form */}
                <Formik
                    enableReinitialize
                    initialValues={{
                        heading_title: editResponseData?.heading || '',
                        // heading_second_text: editResponseData?.sub_heading || '',
                        heading_sub_text: editResponseData?.content || '',
                        cards: editResponseData?.additional_data?.card_design?.map((data) => ({
                            image: {
                                fileUrl: data?.logo,
                                progress: 100,
                                type: "image"
                            },
                            card_title: data?.title,
                            cart_title_secondtext: data?.cart_title_secondtext,
                            card_content: data?.content
                        }))
                            || [{ card_title: '', cart_title_secondtext: '', card_content: '', image: null }]
                    }}



                    validationSchema={Yup.object({
                        heading_title: Yup.string().required('Title is required'),
                        // heading_second_text: Yup.string().required('Second Text is required'),
                        heading_sub_text: Yup.string().required('Subtext is required'),
                        cards: Yup.array().of(
                            Yup.object({
                                card_title: Yup.string().required('Card first title is required'),
                                cart_title_secondtext: Yup.string().required('Card last title is required'),

                                card_content: Yup.string().required('Card Content is required'),
                            })
                        )
                    })}
                    onSubmit={(values, { resetForm }) => {
                        console.log("Form values:", values);
                        // handleSubmit(values, resetForm)
                        isPreviewModalOpen ? handleSubmit(values, resetForm) : handlePreviewOpenModal()

                        // resetForm();
                    }}
                >
                    {({ values, setFieldValue, handleSubmit, resetForm }) => (
                        <Form onSubmit={handleSubmit}>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    {/* Heading Section */}
                                    <Grid item xs={12}>
                                        <Typography variant='body2' sx={{ color: "#C38F51" }}>Heading</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <CustomInputLogin
                                            label="Title"
                                            name="heading_title"
                                            inputType="text"
                                            custPlaceholder="Enter Title"
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <CustomInputLogin
                                            label="Subtext"
                                            name="heading_sub_text"
                                            inputType="textarea"
                                            custPlaceholder="Enter Subtext"
                                        />
                                    </Grid>

                                    {/* Card Section */}
                                    <Grid item xs={12}>

                                        <FieldArray name="cards">
                                            {({ push, remove }) => (
                                                <>
                                                    {/* <Grid item xs={12}>
                                                        <Typography variant='body2' sx={{ color: "#C38F51" }}>Card Design</Typography>
                                                    </Grid> */}

                                                    {values.cards.map((card, index) => (
                                                        <Grid container spacing={2} key={index} sx={{ mt: index > 0 ? 1 : 0 }}>
                                                            <Grid item xs={12}>
                                                                <Typography variant='body2' sx={{ color: "#C38F51" }}>Card Design {index + 1}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <CustomInputLogin
                                                                    label="Card First Title"
                                                                    name={`cards.${index}.card_title`}
                                                                    inputType="text"
                                                                    custPlaceholder="Enter Card Title"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <CustomInputLogin
                                                                    label="Card Second Title"
                                                                    // name="heading_second_text"
                                                                    name={`cards.${index}.cart_title_secondtext`}

                                                                    inputType="text"
                                                                    custPlaceholder="Enter Second Text"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={12}>
                                                                <FileUploadComponent
                                                                    name={`cards.${index}.image`}
                                                                    uploadedFile={values.cards[index].image} // Use individual card image
                                                                    setUploadedFile={(file) => {
                                                                        setFieldValue(`cards.${index}.image`, file);
                                                                        console.log(file, "filelelelellele")

                                                                    }}
                                                                    onFileUpload={(file) => setFieldValue(`cards.${index}.image`, file)}

                                                                // name={`cards.${index}.image`}
                                                                // uploadedFile={uploadedFile}
                                                                // setUploadedFile={setUploadedFile}
                                                                // onFileUpload={(file) => setFieldValue(`cards.${index}.image`, file)}
                                                                // onFileUpload={(fileUrl) => {
                                                                //     console.log("File uploaded:", fileUrl);
                                                                //     setFieldValue("image", fileUrl); // Ensure this function is available
                                                                // }}
                                                                // setUploadedFile={(file) => setFieldValue(`cards.${index}.image`, file)}
                                                                />
                                                                {/* <FileUploadComponent name="image" uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} onFileUpload={(file) => setFieldValue('image', file)} /> */}



                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <CustomInputLogin
                                                                    label="Content"
                                                                    name={`cards.${index}.card_content`}
                                                                    inputType="textarea"
                                                                    custPlaceholder="Enter Content"
                                                                />
                                                            </Grid>
                                                            {index > 0 && (
                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="error"
                                                                        onClick={() => remove(index)}
                                                                        sx={{
                                                                            textTransform: "none",
                                                                            color: "white",
                                                                            fontSize: "16px",
                                                                            boxShadow: "none",
                                                                            padding: { xs: "0px 20px", md: "0px 40px" },
                                                                            minHeight: "40px",
                                                                            borderRadius: "23px",
                                                                            background: "#3B4056",
                                                                            "&:hover": { backgroundColor: "#3B4056" },
                                                                        }}
                                                                    // sx={{ textTransform: "none" }}
                                                                    >
                                                                        Remove Card
                                                                    </Button>

                                                                </Grid>)}
                                                        </Grid>
                                                    ))}

                                                    {/* Add Card Button */}
                                                    {values.cards.length < 3 && (
                                                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "end" }}>
                                                            <Button
                                                                variant="outlined"
                                                                onClick={() => push({ card_title: '', card_content: '', image: null })}
                                                                sx={{
                                                                    textTransform: "none",
                                                                    color: "#C38F51",
                                                                    borderColor: "#C38F51",
                                                                    "&:hover": { backgroundColor: "#C38F51", color: "white" },
                                                                }}
                                                            >
                                                                Add Card
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                </>
                                            )}
                                        </FieldArray>
                                    </Grid>

                                </Grid>

                                {/* Action Buttons */}
                                <Grid sx={{ display: "flex", justifyContent: 'end', mt: 4 }}>
                                    <Button
                                        onClick={() => {
                                            onClose()
                                            dispatch(clearCustomerId(null))
                                            dispatch(clearTableGetId(null))
                                        }}
                                        variant="text"
                                        sx={{
                                            textTransform: "none",
                                            color: "black",
                                            fontSize: "16px",
                                            mr: "10px",
                                            padding: { xs: "0px 20px", md: "0px 40px" },
                                            minHeight: "40px",
                                            borderRadius: "23px",
                                            background: "white",
                                            border: "1px solid black",
                                            "&:hover": { backgroundColor: "#3B4056", color: "white" },
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        // onClick={handlePreviewOpenModal}

                                        variant="contained"
                                        sx={{
                                            textTransform: "none",
                                            color: "white",
                                            fontSize: "16px",
                                            boxShadow: "none",
                                            padding: { xs: "0px 20px", md: "0px 40px" },
                                            minHeight: "40px",
                                            borderRadius: "23px",
                                            background: "#C38F51",
                                            "&:hover": { backgroundColor: "#3B4056" },
                                        }}
                                    >
                                        Preview
                                    </Button>
                                </Grid>

                            </DialogContent>

                            <PreviewComponent
                                showSubmitButton={true}
                                open={isPreviewModalOpen}
                                // ModalPreviewComponent={OfferSection}
                                ModalPreviewComponent={ModalPreviewComponent}

                                onClose={handlePreviewCloseModal}
                                values={values}
                                resetForm={resetForm}
                                ParentModalClose={onClose}
                                handleSubmit={handleSubmit}
                                loading={loading}
                                setLoading={setLoading}
                            />
                        </Form>
                    )}
                </Formik>
            </Box>
        </Dialog >
    );
};

export default AboutUsModal;
